export default function CollectionTemplate({ collection, renderSections }) {
  const sections = renderSections({ props: { collection } })
  return <div data-comp="CollectionTemplate">{sections}</div>;
}
